<script lang="ts">
  import Select from "svelte-select";
  import { tryToGetUser, userInfo } from "../user/user-store";
  import type { UserInformationCaseType } from "../user/user-store";
  import axios from "axios";

  let cases: UserInformationCaseType[];
  let selectedCase: UserInformationCaseType;
  let isCaseSelectOpen: boolean = false;
  let isSettingCase: boolean = false;

  let caseExpirationTimeouts: number[] = [];

  userInfo.subscribe((user) => {
    if (!user) return;

    cases = user.cases?.map(c => ({...c, label: `${c.caseNumber}${c.address ? ` - ${c.address}` : ''}`}));
    selectedCase = cases.find((c) => c.isCurrent)!;
    setCaseExpirationTimeouts();
  });

  function handleCaseSelect({detail}: CustomEvent<UserInformationCaseType>) {
    isSettingCase = true;
    axios.post(`/api/Customer/setCurrentCustomer/${detail.customerId}`)
      .then(() => {
        window.location.href = '/';
      })
      .finally(() => isSettingCase = false)
  }

  function setCaseExpirationTimeouts() {
    while(caseExpirationTimeouts.length) {
      clearTimeout(caseExpirationTimeouts.pop())
    }

    cases?.forEach(c => {
      if (c.accessEndDate && new Date(c.accessEndDate) > new Date()) {
        const timeToExpiration = (new Date(c.accessEndDate) as any) - (new Date() as any);
        caseExpirationTimeouts.push(                 //   ↓ 2147483647 stands for max timeout value value available in JS, more info here - https://stackoverflow.com/questions/3468607/why-does-settimeout-break-for-large-millisecond-delay-values
          setTimeout(tryToGetUser, timeToExpiration > 2147483647 ? 2147483647 : timeToExpiration)
        )
      }
    })
  }
</script>

{#if cases?.length > 1}
  <div class="sub-header">
    <div class="g-centered">
      <div class="sub-header-select">
        <Select
          items={cases}
          optionIdentifier="customerId"
          bind:value={selectedCase}
          isClearable={false}
          bind:listOpen={isCaseSelectOpen}
          containerClasses={isCaseSelectOpen ? "opened" : ""}
          isDisabled={isSettingCase}
          on:select={handleCaseSelect}
        />
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  .sub-header {
    @include sm-down {
      background-color: $key-color;
    }

    &-select {
      font-size: 15px;
      color: $text-reverse-color;

      --inputColor: currentColor;
      --disabledColor: currentColor;
      --height: 50px;
      --background: #0b2c61;
      --disabledBackground: #0b2c61;
      --listBackground: #0b2c61;
      --itemHoverBG: #0b2c61;
      --itemIsActiveBG: #0b2c61;
      --border: 1px solid transparent;
      --borderHoverColor: transparent;
      --borderFocusColor: transparent;
      --disabledBorderColor: transparent;
      --listBorder: 1px solid #ddd;
      --borderRadius: 0;
      --listBorderRadius: 0;
      --itemFirstBorderRadius: 0;
      --itemLastBorderRadius: 0;

      @include sm-down {
        --padding: 0 15px 0 0;
      }

      @include sm {
        width: 300px;
        --padding: 0 30px 0 15px;
        --borderHoverColor: transparent #ddd transparent #ddd;
        --borderFocusColor: transparent #ddd transparent #ddd;
        --disabledBorderColor: transparent #ddd transparent #ddd;
      }

      & :global(.selectContainer::after) {
        content: "";
        display: block;
        width: 9px;
        height: 9px;
        position: absolute;
        top: 50%;
        right: 2px;
        transform: translateY(-50%) rotate(45deg);
        transform-origin: center;
        border: 2px solid currentColor;
        border-top: none;
        border-left: none;
        transition: all 0.2s;

        @include sm {
          right: 16px;
        }
      }

      & :global(.selectContainer.opened::after) {
        transform: translateY(-50%) rotate(-135deg);
      }

      & :global(.listContainer) {
        transform: translateY(-5px);
      }

      & :global(.item),
      & :global(.input) {
        cursor: pointer;
      }

      & :global(.item) {
        --height: 45px;
      }

      & :global(.active) {
        position: relative;
        font-weight: 500;
      }

      & :global(.active::before),
      & :global(.item.hover::before) {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 4px;
        height: 100%;
        background-color: currentColor;
      }

      & :global(.item.hover:not(.active)::before) {
        background-color: rgba($color: $text-reverse-color, $alpha: 0.5);
      }
    }
  }
</style>
